import isFunction from '../utils/is-function';
import validateFileEnding from './validate-file-ending';
const loadGivenFile = (getFile, allowedTypes, isMulti) => Promise.resolve(isFunction(getFile) ? getFile() : getFile).then((r) => {
    const toValidate = isMulti ? r : r.file;
    const isCurrentFileAllowed = validateFileEnding(toValidate, allowedTypes);
    if (Array.isArray(isCurrentFileAllowed)) {
        const [allFilesValid, invalidFile] = isCurrentFileAllowed;
        if (allFilesValid) {
            return r;
        }
        // eslint-disable-next-line prefer-promise-reject-errors -- need to pass invalid file to remove it
        return Promise.reject({
            error: new Error('An invalid file ending was found'),
            invalidFile,
        });
    }
    if (isCurrentFileAllowed) {
        return r;
    }
    return Promise.reject(new Error('File ending is not allowed.'));
});
export default loadGivenFile;
